var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _g2, _path15, _g3, _path16, _path17, _path18, _g4, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 60,
    viewBox: "0 0 300 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_1131)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.573 18.1131C124.76 18.1131 125.318 18.0187 125.412 17.1728V15.117C125.318 14.461 124.948 14.2711 124.76 14.1836H105.047C104.772 14.1836 104.396 14.461 104.309 15.4003V49.1764C104.309 50.2102 104.867 50.399 105.047 50.399H124.573C124.573 50.399 125.318 50.4875 125.412 49.4665V47.4108C125.318 46.6534 124.948 46.4783 124.666 46.4783H108.675V34.3043H124.666C124.853 34.3043 125.317 34.1154 125.412 33.3718V31.3092C125.318 30.5577 124.948 30.3757 124.666 30.3757H108.675V17.9242L124.573 18.1131Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4488 50.5895H96.3983C97.7019 50.5895 97.6071 49.7456 97.6071 49.7456V15.0242C97.6071 14.4626 97.2377 14.3682 97.143 14.3682H96.2156C96.1218 14.3682 95.8403 14.4626 95.5638 14.8413L81.4276 34.5823L67.2035 14.8403C66.9211 14.4616 66.6456 14.3672 66.5518 14.3672H65.5306C65.4368 14.3672 65.0664 14.4616 65.0664 15.0233V49.8321C65.0664 50.1223 65.343 50.5895 66.2693 50.5895H68.2247C69.3407 50.5895 69.4345 49.9344 69.4345 49.7456V24.3833L81.1521 40.5754H81.5215L93.239 24.2888V49.7456C93.24 50.2108 93.5156 50.5895 94.4488 50.5895Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.898 30.4682H148.934C148.753 30.5567 148.283 30.7456 148.283 31.5915V33.2754C148.376 34.0259 148.659 34.3033 148.934 34.3987H161.116C160.189 41.6075 154.423 47.0321 147.449 47.1324C139.917 47.1324 133.688 40.6751 133.688 32.5239C133.688 24.3816 139.917 17.9233 147.449 17.9233C152.005 17.9233 156.096 20.3587 158.609 24.1042C158.609 24.1042 158.884 24.5715 159.536 24.6659H162.693C163.07 24.5715 163.07 24.2872 163.07 24.1928C163.07 24.1042 162.969 24.0098 162.969 24.0098C159.999 18.2075 154.14 14.1836 147.354 14.1836C137.591 14.1836 129.777 22.5088 129.777 32.7147C129.777 42.8174 137.591 51.1446 147.448 51.1446C157.204 51.1446 165.025 42.8174 165.025 32.6193V31.9633C164.926 30.7456 164.274 30.5567 163.898 30.4682Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.239 49.6571L183.148 14.4616C182.972 14.1843 182.784 14.0898 182.597 14.0898H181.293C181.106 14.0898 180.917 14.1843 180.742 14.4616L164.375 49.7456C164.375 49.9344 164.375 50.4007 165.115 50.4892H167.909C168.461 50.4892 168.737 50.2118 168.837 50.0357L172.646 41.5079H191.055L194.954 50.1233C195.054 50.3121 195.33 50.4892 195.894 50.4892H198.312C199.34 50.4007 199.34 49.7456 199.239 49.6571ZM174.501 37.6718L181.945 21.0144L189.477 37.6718H174.501Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.261 49.4673V44.0309C265.16 43.4762 264.785 43.2981 264.609 43.1978H250.936V34.8647H264.058C264.234 34.8647 264.609 34.6758 264.709 34.1142V29.0624C264.609 28.4063 264.058 28.2234 263.857 28.2234H250.848V20.6417H264.421C264.709 20.6417 265.161 20.4529 265.161 19.7014V14.8385C265.161 13.9935 264.509 13.8991 264.333 13.8047H243.781C243.504 13.8991 243.027 14.0889 243.027 14.8385V49.1004C243.027 50.1214 243.956 50.1214 243.956 50.1214H264.42C264.784 50.1224 265.16 49.9335 265.261 49.4673Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.916 28.4061H221.925C221.749 28.4061 221.098 28.5006 221.098 29.3455V34.8635C221.098 35.615 221.549 35.7979 221.837 35.7979H230.672C229.182 40.472 225.082 43.7514 220.347 43.7514C214.493 43.7514 209.468 38.7055 209.468 32.1517C209.468 25.5989 214.493 20.5471 220.347 20.5471C222.954 20.5471 225.284 21.4806 227.138 23.1645C227.138 23.1645 227.689 23.7252 228.53 23.7252H235.686C236.338 23.7252 236.438 23.3534 236.338 23.1645C233.279 17.2668 227.314 13.1484 220.347 13.1484C210.12 13.1484 202.125 21.8524 202.125 32.2461C202.125 42.6409 210.121 51.2445 220.347 51.2445C230.572 51.2445 238.569 42.5396 238.569 32.1517V29.3445C238.569 28.6904 238.192 28.4061 237.916 28.4061Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.403 49.6552V14.6496C300.317 14.3653 300.129 13.9935 299.577 13.8991H293.899C293.16 13.8991 292.973 14.3653 292.973 14.6496V34.5804L272.983 14.1834C272.708 13.8991 272.507 13.8047 272.419 13.8047H270.652C270.551 13.8047 270.188 13.8991 270.188 14.3653V49.4663C270.275 49.7437 270.375 50.1214 271.027 50.2099H277.168C278.095 50.1214 278.095 49.2775 278.095 49.2775V29.3447L298.084 49.7427C298.359 50.0329 298.548 50.1204 298.735 50.1204H300.227C300.027 50.209 300.317 50.1214 300.403 49.6552Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.012 7.06641H195.056C193.753 7.06641 193.853 7.90542 193.853 7.90542V25.1313C193.941 25.4087 194.129 25.7874 195.056 25.7874H197.012C198.314 25.7874 198.214 24.9425 198.214 24.9425V7.72247C198.214 7.43821 197.938 7.06641 197.012 7.06641Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5462 11.8445V17.2691H33.7303V12.9678C33.7303 11.9399 34.5638 11.094 35.5918 10.9996H37.4466V2.66748C37.4466 1.26781 36.3306 0.144531 34.94 0.144531H23.0339C21.6423 0.144531 20.5273 1.26781 20.5273 2.66748V8.28683H22.2003C24.0619 8.47076 25.5462 9.97174 25.5462 11.8445Z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9402 17.3616H33.7305V18.8626C33.7305 19.8905 34.564 20.8239 35.592 20.7295H41.2627C42.2839 20.7295 43.1243 19.8905 43.1243 18.7682V13.0603C43.1243 12.0255 42.2849 11.1875 41.2627 11.1875H37.3588V14.8386C37.4468 16.1439 36.3308 17.3616 34.9402 17.3616Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1207_1131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 3,
    width: 16,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2676 15.0215C21.2676 15.8664 22.0132 16.6169 22.8527 16.6169H35.1214C36.0556 16.6169 36.7074 15.8664 36.7074 15.0215V13.7094C36.7074 13.7094 31.6816 5.47758 21.1797 3.69922L21.2676 15.0215Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1207_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8031 3.79297H21.2695V16.7038H36.8031V3.79297Z",
    fill: "#FEFEFE"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7305 13.0592V17.3605H34.9402C36.3308 17.3605 37.4468 16.2372 37.4468 14.8376V11.1864H35.592C34.564 11.091 33.7305 12.0245 33.7305 13.0592Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1052 8.46875H3.41337C1.55865 8.46875 -0.0273438 9.96973 -0.0273438 11.9369V30.7455C-0.0273438 32.6183 1.46386 34.2087 3.41337 34.2087H12.9V29.995C12.9 27.655 14.7616 25.6937 17.1792 25.6937H25.4512V11.9369C25.545 9.96973 24.0606 8.46875 22.1052 8.46875Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1207_1131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 8,
    width: 6,
    height: 10
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1066 8.46875H20.4336V14.8386C20.4336 16.2383 21.5486 17.3615 22.946 17.3615H25.4525V11.9369C25.5463 9.96973 24.0619 8.46875 22.1066 8.46875Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1207_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5463 8.46875H20.4336V17.3615H25.5463V8.46875Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1207_1131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 13,
    width: 24,
    height: 21
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00391 28.6913V30.6526C1.00391 32.0592 2.11987 33.088 3.41661 33.088H22.2033C23.5938 33.088 24.6218 31.9647 24.6218 30.6526V13.4336C8.6241 16.1454 1.00391 28.6913 1.00391 28.6913Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1207_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00391 13.3398H24.6208V33.0877H1.00391V13.3398Z",
    fill: "#FEFEFE"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7478 25.5977H25.5472V30.6495C25.5472 32.5222 24.0618 34.1127 22.2012 34.1127H13.0898V55.5445C13.0898 57.8786 14.9446 59.8468 17.3641 59.8468H42.8426C45.1674 59.8468 47.1227 57.98 47.1227 55.5445V29.9049C46.9341 27.5649 45.0726 25.5977 42.7478 25.5977Z",
    fill: "#FEFEFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5482 30.6495V25.5977H17.2704C14.9456 25.5977 12.9961 27.4704 12.9961 29.9049V34.1118H22.1075C24.0638 34.1118 25.5482 32.5222 25.5482 30.6495Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1207_1131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 32,
    width: 32,
    height: 27
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3008 52.7333V55.3566C14.3008 57.1487 15.7861 58.6369 17.5529 58.6369H42.5672C44.334 58.6369 45.8193 57.1487 45.8193 55.3566V32.4297C24.4334 36.0818 14.3008 52.7333 14.3008 52.7333Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1207_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.207 32.4297H45.8204V58.6369H14.3008L14.207 32.4297Z",
    fill: "#FEFEFE"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1066 8.46875H20.4336V14.8386C20.4336 16.2383 21.5486 17.3615 22.946 17.3615H25.4525V11.9369C25.5463 9.96973 24.0619 8.46875 22.1066 8.46875Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegagen);
export default __webpack_public_path__ + "static/media/megagen.ee31f072effefcfd40373b220dbf85b7.svg";
export { ForwardRef as ReactComponent };